// src/components/PublicRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function PublicRoute({ children }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  // Validate that both token and role exist and role is valid
  const validRoles = ["Admin", "Staff"];
  const isValidSession = token && role && validRoles.includes(role);

  // If user is already logged in with valid session, redirect to their dashboard
  if (isValidSession) {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise, allow access to auth pages
  return children;
}
